import React, { useState } from 'react';
import YesNoRadioGroup from './YesNoRadioGroup';
import PrizesRadioGroup from './PrizesRadioGroup';
import LeagueFeesRadioGroup from './LeagueFeesRadioGroup';
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./LeagueFeatures.module.css";

const LeagueFeatures = () => {
  const [selectedValue, setSelectedValue] = useState('');

  const navigate = useNavigate();

  const handleNextClick = () => {
    navigate("/invitemembers");
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value);
  };

  return (
    <div className={styles.container}>
      <p className={styles.title}>Does your league have any of these?</p>
      <div className={styles.featureOptions}>
        <div className={styles.featureType}>
          <p>Keepers</p>
          <YesNoRadioGroup />
        </div>
        <div className={styles.featureType}>
          <p>Prizes</p>
          <PrizesRadioGroup />
        </div>
        <div className={styles.featureType}>
          <p>League fees</p>
          <LeagueFeesRadioGroup />
        </div>
      </div>
      <div className={styles.buttonContainer}>
        <Button
          className={styles.buttonPrimary}
          disableElevation
          variant="contained"
          onClick={handleNextClick}
        >
          Next
        </Button>
        <div className={styles.skip}>Skip</div>
      </div>
    </div>
  );
};

export default LeagueFeatures;

